import React from 'react';
export function CloseCTASection() {
  return <section className="py-20 px-5 bg-cream-dark text-center reveal" data-id="element-75">
      <h2 className="font-playfair text-[clamp(1.8rem,3.5vw,2.8rem)] font-black text-text-dark mb-4 leading-[1.2]" data-id="element-76">
        Tu hijo está a 21 días de
        <br data-id="element-77" />
        <em className="italic text-terracotta" data-id="element-78">
          sentirse orgulloso de sí mismo.
        </em>
      </h2>
      <p className="font-lora text-base text-text-mid max-w-[500px] mx-auto mb-9 leading-[1.7] italic" data-id="element-79">
        No dejes pasar otro mes de frustración. Dale las herramientas que
        necesita para descubrir que leer puede ser un placer, no un castigo.
      </p>

      <a href="https://www.gaiadigitalpro.com/checkouts/cn/hWN9M59KdNNduHrWqQMttkBd/es-ar?_r=AQABgGschoRR_SY96W8jodDFHW8nWvDOxXINeW34G_-0IYY&preview_theme_id=163059597347" target="_blank" rel="noopener noreferrer" className="inline-block bg-terracotta text-white font-sans text-[0.95rem] font-medium tracking-[0.06em] uppercase py-[18px] px-10 rounded text-decoration-none border-none cursor-pointer transition-all duration-200 hover:bg-terracotta-light hover:-translate-y-0.5" data-id="element-80">
        QUIERO EMPEZAR HOY MISMO →
      </a>

      <div className="mt-3.5 text-[0.8rem] text-text-light" data-id="element-81">
        Acceso inmediato · Garantía de 21 días · Solo $17.900
      </div>
    </section>;
}